/**
 * Shared accounting-standard literals. These are the EXACT strings the backend
 * emits for a filing's accounting standard. The MPERS literal is the plural
 * "Standards" form — that is what the backend sends and what every MPERS filing
 * matches on. (An older singular "Entity" spelling existed in a few comparisons
 * and never matched the backend; it was a latent bug and has been removed.)
 *
 * Having the literals in ONE place lets `pickSchema` drop its per-call
 * `mpersLiteral` argument and lets each role rules file re-export the MPERS
 * constant instead of repeating the string.
 */
export const MFRS_ACCOUNTING_STANDARD = 'Malaysian Financial Reporting Standards';
export const MPERS_ACCOUNTING_STANDARD = 'Malaysian Private Entities Reporting Standards';

/**
 * Generic MFRS/MPERS schema selector. Replaces the per-sheet
 * pickRole<N>Schema() / pickRole<N>SchemaFile() ternaries. Each call site still
 * supplies its own MFRS/MPERS values — only the branching is shared.
 *
 * Selection is MFRS-default across the board: any value other than the exact
 * shared MPERS literal (incl. null/undefined/'') selects MFRS. MPERS is chosen
 * only on an exact match against `MPERS_ACCOUNTING_STANDARD`.
 */
export function pickSchema<T>(accountingStandard: string | null | undefined, mfrs: T, mpers: T): T {
  return accountingStandard === MPERS_ACCOUNTING_STANDARD ? mpers : mfrs;
}
